module.exports = __webpack_public_path__ + "static/Safeway_pin_hover-c1e619647f1a8ca5cddef25d1a3b5c37.png";